import {
  getIdEstadoCita,
  CITA_ESTADO_EN_CONSULTA,
  CITA_ESTADO_FINALIZADA,
} from "./citaFinalizadaAlert";

/* ============================================================================
   CONSULTA-ABIERTA -- el medico abre la consulta ANTES de escribir

   Antes, escribir la enfermedad actual abria la consulta sola: el estado lo
   decidia el teclado. Ahora la apertura es un acto explicito, y hasta que
   ocurre no hay historia clinica que escribir.

   La regla vive aqui y no dentro del componente porque la comparte el boton
   (que ofrece la transicion) y el bloqueo de los formularios (que la exige).
   Tenerla en dos sitios era exactamente como se rompio antes: la UI decidia
   por el TEXTO del estado y renombrar el catalogo la habria roto en silencio.

   Los ids son los mismos que aplica el backend en `guardConsultaAbierta`.
   ========================================================================== */

/** Estados desde los que TODAVIA se puede abrir una consulta (no terminales). */
export const ESTADOS_QUE_PUEDEN_INICIAR_CONSULTA = [1, 2, 3, 4];

/** La consulta esta abierta: es lo unico que habilita escribir en la historia. */
export function consultaAbierta(cita) {
  return getIdEstadoCita(cita) === CITA_ESTADO_EN_CONSULTA;
}

/**
 * Transicion que la UI ofrece, o null si no ofrece ninguna.
 *
 * ANTES solo se ofrecia abrir desde "En sala de espera" (3). Eso funcionaba
 * mientras escribir abria la consulta por detras; ahora dejaria al medico sin
 * poder empezar en toda cita CONFIRMADA que no pasa por recepcion -- que es
 * el caso normal de la consulta agendada. La lista es la misma que acepta el
 * backend, ni una mas.
 */
export function decidirTransicionConsulta(cita) {
  const actual = getIdEstadoCita(cita);
  if (ESTADOS_QUE_PUEDEN_INICIAR_CONSULTA.includes(actual)) return CITA_ESTADO_EN_CONSULTA;
  if (actual === CITA_ESTADO_EN_CONSULTA) return CITA_ESTADO_FINALIZADA;
  return null;
}

/** Texto del boton, derivado de la MISMA decision -- no de una segunda regla. */
export function etiquetaBotonConsulta(cita) {
  const destino = decidirTransicionConsulta(cita);
  if (destino === CITA_ESTADO_EN_CONSULTA) return "Iniciar consulta";
  if (destino === CITA_ESTADO_FINALIZADA) return "Finalizar cita";
  return "Sin acción";
}

/** Por que esta bloqueada la escritura, o null si no lo esta. */
export function motivoBloqueoConsulta(cita) {
  if (consultaAbierta(cita)) return null;
  if (getIdEstadoCita(cita) === CITA_ESTADO_FINALIZADA) return "FINALIZADA";
  return "SIN_ABRIR";
}
